import { render } from "./ColumnUi.vue?vue&type=template&id=4ec534d5&scoped=true"
import script from "./ColumnUi.vue?vue&type=script&lang=js"
export * from "./ColumnUi.vue?vue&type=script&lang=js"

import "./ColumnUi.vue?vue&type=style&index=0&id=4ec534d5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4ec534d5"

export default script